// Mock data for Multi-Omix Sustainability Leader Awards

export const eventInfo = {
  title: "Sustainability Leader Awards",
  subtitle: "Life Sciences",
  tagline: "Do We Have Another Earth To Go To?",
  date: "October 28, 2026",
  day: "Wednesday",
  location: "Delhi NCR, India",
  targetDate: "2026-10-28T09:00:00",
};

export const stats = [
  {
    value: "79%",
    label: "Global carbon emissions",
    sub: "from infrastructure & industry",
  },
  {
    value: "5.5M",
    label: "Tonnes of plastic waste",
    sub: "from labs globally each year",
  },
  {
    value: "5-10\u00d7",
    label: "More energy consumed",
    sub: "vs standard office buildings",
  },
  {
    value: "2030",
    label: "UN SDG deadline",
    sub: "to secure a liveable future",
  },
];

export const priorities = [
  {
    id: 1,
    icon: "Zap",
    title: "Energy & Carbon Reduction",
    color: "amber",
    accent: "#F59E0B",
    bg: "#FEF3C7",
    description:
      "Net-zero lab operations powered by renewable energy. Reduce embodied carbon in equipment. Deploy energy-efficient HVAC and low-flow fume hoods.",
    points: ["Renewable energy sourcing", "Efficient HVAC systems", "Low-flow fume hoods"],
  },
  {
    id: 2,
    icon: "Leaf",
    title: "Biodiversity & Green Lab Spaces",
    color: "green",
    accent: "#10B981",
    bg: "#D1FAE5",
    description:
      "Responsible sourcing of biological materials and reagents. Habitat protection and green space integration across facilities.",
    points: ["Responsible reagent sourcing", "Habitat protection", "Green space integration"],
  },
  {
    id: 3,
    icon: "Recycle",
    title: "Plastic Waste Management",
    color: "blue",
    accent: "#3B82F6",
    bg: "#DBEAFE",
    description:
      "Single-use plastic reduction. Closed-loop consumable systems. Supplier take-back schemes. Circular procurement models.",
    points: ["Single-use reduction", "Closed-loop systems", "Circular procurement"],
  },
  {
    id: 4,
    icon: "Users",
    title: "Social Value & Community Impact",
    color: "rose",
    accent: "#EC4899",
    bg: "#FCE7F3",
    description:
      "STEM outreach. Local supply chains. Equitable access to research benefits. Strong health & safety culture.",
    points: ["STEM outreach", "Local supply chains", "Equitable research access"],
  },
  {
    id: 5,
    icon: "Shield",
    title: "Resilience & Climate Adaptation",
    color: "teal",
    accent: "#0D9488",
    bg: "#CCFBF1",
    description:
      "Climate-proof cold chains. Flood-resilient infrastructure. Business continuity plans for extreme weather events.",
    points: ["Climate-proof cold chains", "Flood-resilient infra", "Business continuity"],
  },
];

export const awardCategories = [
  { title: "Sustainable Lab of the Year", icon: "Beaker", tier: "gold" },
  { title: "Scientist of the Year", icon: "Microscope", tier: "gold" },
  { title: "SRF of the Year", icon: "GraduationCap", tier: "silver" },
  { title: "JRF of the Year", icon: "BookOpen", tier: "silver" },
  { title: "Energy Efficiency Leader", icon: "Zap", tier: "gold" },
  { title: "Sustainable Corporate of the Year", icon: "Building2", tier: "platinum" },
  { title: "Plastic Waste Reduction Initiative", icon: "Recycle", tier: "gold" },
  { title: "MD of the Year", icon: "Award", tier: "platinum" },
  { title: "Employee of the Year", icon: "Star", tier: "silver" },
];

export const nominationSteps = [
  {
    step: "01",
    title: "Lead by Example",
    icon: "Compass",
    description:
      "Put sustainability on every lab meeting agenda. Champion it visibly. Highlight specific moments where you drove change personally.",
  },
  {
    step: "02",
    title: "Gather Evidence",
    icon: "ClipboardCheck",
    description:
      "Collect measurable data: energy reduction %, plastic waste diverted (kg), social value delivered, biodiversity outcomes, climate resilience actions.",
  },
  {
    step: "03",
    title: "Cross-Functional Collaboration",
    icon: "Network",
    description:
      "Strong nominations show engagement across research, operations, procurement, finance and HR. Show how you broke down silos.",
  },
  {
    step: "04",
    title: "Progress, Not Perfection",
    icon: "TrendingUp",
    description:
      "Document your improvement journey, not just the endpoint. Judges value honesty, ambition, and a clear roadmap forward.",
  },
];

export const evidenceChecklist = [
  "Energy reduction %",
  "Plastic waste diverted (kg)",
  "Social value delivered",
  "Biodiversity outcomes",
  "Renewable energy %",
  "Supplier sustainability data",
  "STEM outreach records",
  "Climate resilience actions",
];

export const jury = [
  {
    name: "Dr. Shreesh Srivastava",
    role: "Group Leader, Systems Biology for Biofuels",
    org: "ICGEB, New Delhi, India",
    image:
      "https://images.unsplash.com/photo-1582719471137-c3967ffb1c42?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    name: "Dr. Himanshu Vashistha",
    role: "Lead Regional Technical Specialist",
    org: "FIND (Foundation for Innovative New Diagnostics)",
    image:
      "https://images.unsplash.com/photo-1616996691748-3f5f78093ab0?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
];

export const sdgFacts = [
  "The 17 Sustainable Development Goals were adopted by the UN in 2015 as a universal call to action.",
  "Action in one SDG area affects outcomes in others \u2014 balance social, economic, and environmental sustainability.",
  "Countries have committed to prioritize progress for those who're furthest behind.",
  "Achieving SDGs requires creativity, technology, and financial resources from all of society.",
];

export const sustainabilityCategories = [
  "Energy & Carbon Reduction",
  "Biodiversity & Green Lab Spaces",
  "Plastic Waste Management",
  "Social Value & Community Impact",
  "Resilience & Climate Adaptation",
];

export const contact = {
  name: "Vipan Manhas",
  phone: "+91 9999990857",
  email: "vipan_manhas@funforlab.com",
};

export const heroImage =
  "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const labImage =
  "https://images.unsplash.com/photo-1602052577122-f73b9710adba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const natureImage =
  "https://images.unsplash.com/photo-1629267699730-f7467e129e65?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const scienceImage =
  "https://images.unsplash.com/photo-1753357278474-74cd2cac70ec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
